import { Component, OnInit } from '@angular/core';
import { TableCoreService } from '@app/shared/table/services/table-core.service';
import { DashboardListService } from '@app/dashboard/dashboard-list.service';
import { ActivatedRoute } from '@angular/router';
import { switchAll, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ListGridOptionsComponent } from '@app/shared/components/list-grid-options/list-grid-options.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TableComponent } from '@app/shared/table/table.component';

const URLMap = {
  'district-report': 'district-report',
  'weights-report': 'weights-report',
  'units-report': 'units-report',
  'contractors-report': 'contractors-report',
  'trash-report': 'trash-report'
};
@Component({
  selector: 'app-dashboard-reports',
  templateUrl: './dashboard-reports.component.html',
  styleUrls: ['./dashboard-reports.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    ListGridOptionsComponent,
    TableComponent
  ]
})
export class DashboardReportsComponent implements OnInit {
  tableData: any[];
  title: string = 'تقرير لعدد البلديات بالمردم';
  public columns: any[] = [];
  public listOptions: any[] = [];
  url: string = null;
  headerSmallSize: boolean = false;
  showTitle: boolean = false;
  constructor(
    private tableCoreService: TableCoreService,
    public service: DashboardListService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.url.subscribe(segment => {
      this.url = URLMap[segment[0].path] ? URLMap[segment[0].path] : null;
      this.getData();
    });
  }
  openForm(item: any) {}
  getData() {
    this.service
      .getHeader(this.url)
      .pipe(
        switchMap((res: any) => {
          if (!res) {
            this.columns = [];
            return of(null);
          }
          this.columns = res;
          return this.service.getData(this.url);
        })
      )
      .subscribe(res => {
        this.tableData = res;
      });
  }

  filterPeriod(period: string) {
    console.log(period);
    if (period == 'yesterday') {
      this.tableData = [];
    } else {
      this.getData();
    }
  }
  exportMultiple() {
    console.log('EXPORT');
  }
}
